var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIconThreads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3103 8.22798C10.5755 8.22798 9.97977 7.61563 9.97977 6.86044C9.97977 6.10548 10.5755 5.49325 11.3103 5.49325C12.0452 5.49325 12.6406 6.10548 12.6406 6.86044C12.6406 7.61563 12.0452 8.22798 11.3103 8.22798ZM7.5 8.22798C6.76516 8.22798 6.16978 7.61563 6.16978 6.86044C6.16978 6.10548 6.76516 5.49325 7.5 5.49325C8.23462 5.49325 8.83057 6.10548 8.83057 6.86044C8.83057 7.61563 8.23462 8.22798 7.5 8.22798ZM3.68984 8.22798C2.955 8.22798 2.35927 7.61563 2.35927 6.86044C2.35927 6.10548 2.955 5.49325 3.68984 5.49325C4.42467 5.49325 5.02023 6.10548 5.02023 6.86044C5.02023 7.61563 4.42467 8.22798 3.68984 8.22798ZM15 7.0071C15 3.13696 11.6421 0 7.5 0C3.35786 0 0 3.13696 0 7.0071C0 10.877 3.35786 14.0144 7.5 14.0144C7.89823 14.0144 8.28683 13.9767 8.66839 13.9208L12.0215 16L12.3183 12.3738C13.9568 11.0883 15 9.16224 15 7.0071Z",
    fill: "#E9A96D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconThreads);
export default __webpack_public_path__ + "static/media/message-icon-threads.62744d6183aa28faef9b4b92008871b5.svg";
export { ForwardRef as ReactComponent };